import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Calling Ajax in connect allows page to load first
    this.getClickData();
    this.getClickThroughData();
  }

  getClickData() {
    const formData = new FormData();
    formData.append('your', 'data');
    formData.append('and', 'more');

    fetch(`/admin/categories/${this.element.dataset.category}/click_data`, {
      method: 'POST',
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
      },
      body: formData
    })
    .then(response => response.json())
    .then(response => {
      let clickData = response.data;
      // console.log(clickData);
      for (let key in clickData) {
        // Key is the Entry ID
        // clickData[key] is the hash of data
        // console.log(key + ": " + JSON.stringify(clickData[key]));
        const tdElement = document.querySelector(
          `tr[data-id="${key}"] td.click-data__today`
        );
        if (tdElement) {
          tdElement.innerHTML = clickData[key]['today'];
        }
      }
    })
    .catch(error => {
      console.error('Error fetching click data:', error);
    });
  }
  getClickThroughData() {
    const formData = new FormData();
    formData.append('your', 'data');
    formData.append('and', 'more');

    fetch(`/admin/categories/${this.element.dataset.category}/click_through_data`, {
      method: 'POST',
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
      },
      body: formData
    })
    .then(response => response.json())
    .then(response => {
      let clickData = response.data;
      // console.log(clickData);
      for (let key in clickData) {
        // Key is the Entry ID
        // clickData[key] is the hash of data
        // console.log(key + ": " + JSON.stringify(clickData[key]));
        const tdElement = document.querySelector(
          `tr[data-id="${key}"] td.click-through-data__today`
        );
        if (tdElement) {
          tdElement.innerHTML = clickData[key]['today'];
        }
      }
    })
    .catch(error => {
      console.error('Error fetching click through data:', error);
    });
  }
}
